import JourneyCardLayout from '@acorn-portal/shared/src/layouts/journey-card-layout';
import HelperModal from '@acorn-portal/shared/src/components/modal/HelperModal';
import { useAppSelector } from '@acorn-portal/shared/src/hooks/reduxHook';
import { useDiscardMta } from '@acorn-portal/shared/src/hooks/use-discard-mta';
import { FC, useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { ROUTE_PATHS } from '@acorn-portal/shared/src/utils/Routes';
import RestartCardPaymentOption from './components/card-payment-options';

const PaymentOptions: FC = () => {
	const [open, toggleModal] = useState(false);
	const subscription = useAppSelector((state) => state.subscription);
	const navigate = useNavigate();
	const { discardLoading } = useDiscardMta();
	const { quoteData } = subscription;

	useEffect(() => {
		if (!quoteData?.quoteResponse.quoteRef) {
			navigate(ROUTE_PATHS.home);
		}
	}, []);

	return (
		<JourneyCardLayout pageTitle={'Payment Options'} loading={discardLoading}>
			<RestartCardPaymentOption toggleModal={toggleModal} />
			<HelperModal
				open={open}
				onClose={() => {
					toggleModal(false);
				}}
				title='Discard The Changes?'
				description='Are you sure you wish to discard the changes?'
				closeText='No'
				submitText='Yes'
				onSubmit={() => navigate(-1)}
			/>
		</JourneyCardLayout>
	);
};
export default PaymentOptions;
